// key: latvian translation
export default {
	'Phone must be verified': 'Tālrunis jābūt apstiprinātam'
}
